
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import {Observable} from 'rxjs/Rx';

import { Usuario } from '../model/usuario'



@Injectable()
export class UsuarioService {

  //public proyecto: Proyecto;

  constructor (private http: Http
  ) {


  }


     getUsuarios(usuariosUrl: string, access_token: string): Observable<Usuario[]>{

       var usuarios: Usuario[] = [];
       var url = usuariosUrl + "?access_token=" + access_token;
       console.log("URL: " + url);
       return this.http.get(url).pipe(
        // ...and calling .json() on the response to return data
          map((res:Response) => {
            console.log("Respuesta: " + res.text());
            JSON.parse(res.text()).forEach(item => {
              //console.log("JSONVideo: " + item.ChannelTitle);
             //var proyecto: Proyecto = item as Proyecto;
             usuarios.push(item as Usuario);

           });
            return usuarios;
           }));



     }

     getUsuario(usuariosUrl: string, idUsuario: number,
        access_token: string): Observable<Usuario>{
       var url = usuariosUrl + "/" + idUsuario + "?access_token=" + access_token;
       console.log("URL: " + url);
       return this.http.get(url).pipe(
        // ...and calling .json() on the response to return data
          map((res:Response) => {
            console.log("Respuesta: " + res.text());
            let item = JSON.parse(res.text());

             return item as Usuario;
           }));

     }

      }



// WEBPACK FOOTER //
// ./src/app/services/usuarioService.ts